// image.service.ts
import { Component, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SimilarTvSerieService {

  constructor(private http: HttpClient) {}
  getSimilarTvSeries(id: number):Observable<any> {
    return this.http.get<any>(`${environment.backendUrl}/api/tv/${id}/similar`);
  }
}